import {
  EncoderDecoder,
  EncoderDecoderFct,
} from '@iotize/common/converter/api';
import { BodyDecoder } from '@iotize/tap/client/api';

type PipeConverterType<InputType, OutputType> =
  | EncoderDecoder<OutputType, InputType>
  | EncoderDecoderFct<InputType, InputType>;

export class PipeConverterBuilder {
  constructor(
    public aliases: { [key: string]: PipeConverterType<any, any> } = {},
  ) {}

  public pipe<T>(converter: PipeConverterType<Uint8Array, T> | string) {
    return new PipeConverter<T>([], this.aliases).pipe<T>(converter as any);
  }
}

/**
 * Pipe multiple converter one after another
 */
export class PipeConverter<T> implements BodyDecoder<T> {
  constructor(
    public converters: PipeConverterType<any, any>[],
    public aliases: { [key: string]: PipeConverterType<any, any> } = {},
  ) {}

  decode(body: Uint8Array): T {
    let output: any = body;
    for (let converter of this.converters) {
      if (typeof converter == 'function') {
        output = converter(output);
      } else {
        output = converter.decode(output);
      }
    }
    return output as T;
  }

  encode(value: T): Uint8Array {
    let output: any = value;
    const reversedConverters = [...this.converters].reverse();
    for (let converter of reversedConverters) {
      if (typeof converter == 'function') {
        output = converter(output);
      } else {
        output = converter.encode(output);
      }
    }
    return output;
  }

  public pipe<OutputType>(
    converter: PipeConverterType<T, OutputType> | string,
  ): PipeConverter<OutputType> {
    if (typeof converter === 'string') {
      if (!(converter in this.aliases)) {
        throw new Error(`Illegal argument, missing converter id: ${converter}`);
      }
      converter = this.aliases[converter];
    }
    this.converters.push(converter);
    return this as any;
  }

  public static pipe<T>(converter: PipeConverterType<Uint8Array, T>) {
    return new PipeConverter<T>([converter], {});
  }
}
